module.exports = __webpack_public_path__ + "img/collection-weddingRingsBudgetHigh@2x.33025c0.jpg";